export default [
    {
        title: 'Home',
        route: 'dashboard',
        icon: 'HomeIcon',
    },
    {
        title: 'محل کار',
        icon: 'MapIcon',
        children: [
            {
                title: 'لیست محل کار',
                route: 'office-list',
                icon: 'ListIcon',
            },
            {
                title: 'افزدون محل کار',
                route: 'office-add',
                icon: 'PlusIcon',
            },
        ],
    },
    {
        title: 'شیفت',
        icon: 'CalendarIcon',
        children: [
            {
                title: 'لیست شیفت ها',
                route: 'shift-list',
                icon: 'ListIcon',
            },
            {
                title: 'افزدون شیفت',
                route: 'shift-add',
                icon: 'PlusIcon',
            },
        ],
    },
    {
        title: 'پرسنل',
        icon: 'UserIcon',
        children: [
            {
                title: 'لیست پرسنل',
                route: 'user-list',
                icon: 'ListIcon',
            },
        ],
    },
    {
        title: 'تردد',
        icon: 'UserIcon',
        children: [
            {
                title: 'لیست تردد',
                route: 'record-list',
                icon: 'ListIcon',
            },
            {
                title: 'افزودن تردد',
                route: 'record-add',
                icon: 'PlusIcon',
            },
        ],
    },
]
